    import { useNavigate } from "react-router-dom";
    import Button from "../components/UI/Button";

    const NewMeetingButton = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/meeting-form");
    };

    return <div>
        <Button onClick={handleClick}>יצירת פגישה חדשה</Button>
    </div>;
    };

    export default NewMeetingButton;